import { configureStore } from '@reduxjs/toolkit';
import eventItemReducer from './EventItemSlice'

const eventItemStore = configureStore({
  reducer: {
    eventItems: eventItemReducer
  }
});

export default eventItemStore;